module.exports = __webpack_public_path__ + "img/germany-cerebrovascular-disease-female.f213faf7.png";